import { render, staticRenderFns } from "./TasksHeader.vue?vue&type=template&id=d76f0e40&scoped=true&"
import script from "./TasksHeader.vue?vue&type=script&lang=ts&"
export * from "./TasksHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TasksHeader.vue?vue&type=style&index=0&id=d76f0e40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d76f0e40",
  null
  
)

export default component.exports